import {EcSiteApiInterface} from '@/config/axios'

export default {
  // ログイン
  login (params = {}) {
    return EcSiteApiInterface.post('/user/login', params).then(res => {
      return res.data
    })
  },

  // トークン再発行
  refreshToken () {
    return EcSiteApiInterface.post('/user/refresh', {}).then(res => {
      return res.data
    }).catch((error) => {
      return error
    })
  },

  // ログアウト
  logout (config = {}) {
    return EcSiteApiInterface.delete('/user/logout', config).then(res => {
      return res.data
    }).catch((error) => {
      return error
    })
  }
}



// WEBPACK FOOTER //
// ./src/xhr/xhr-auth.js